<template>
  <p class="text--center">
    Ratenfinanzierung wählbar ab 99 € bis 5.000 €. Finanzierungssumme 699,00 €, monatliche Rate ab
    58,25 €; Barzahlungspreis entspricht dem Nettodarlehensbetrag. Der effektive Jahreszins von 0 %
    (Nur bei einer Laufzeit von maximal 12 Monaten) entspricht einem festen Sollzinssatz von 0 %
    p.a. Erst- und Schlussrate kann abweichen. Bonität vorausgesetzt. Die Angaben stellen zugleich
    das repräsentative 2/3-Bsp. i.S.d. § 6a IV PAngV dar. Höhe und Anzahl der monatlichen Raten
    können sich verändern, wenn weitere Verfügungen über den Kreditrahmen vorgenommen werden.
    Vermittlung erfolgt ausschließlich für unsere Finanzierungspartner: Novalnet AG, Feringastr. 4,
    85774 Unterföhring. Alle weiteren Informationen zum Thema Ratenzahlung findest Du unter
    <LinkButton
      tag="nuxt-link"
      to="/ratenzahlung"
      text
    >
      https://shop.telekom.de/ratenzahlung
    </LinkButton>
  </p>
</template>
<script setup>
import { LinkButton } from '@i22team/td-longtail-vue-components';
</script>
